const carouselItems = [
  {
    id: 1,
    title: '2026 暑期档·动作巨制集结',
    tag: '专题推荐',
    desc: '今夏最值得期待的动作大片一次看完，从热血格斗到极限追击，每一部都让你肾上腺素飙升。高清画质搭配杜比音效，在家也能感受影院级震撼体验。',
    img: 'https://readdy.ai/api/search-image?query=Epic%20action%20movie%20scene%20collage%20dark%20dramatic%20lighting%20with%20explosive%20warm%20orange%20and%20gold%20accents%2C%20cinematic%20composition%2C%20intense%20atmosphere%2C%20film%20grain%20texture%2C%20dark%20theater%20background%2C%20blockbuster%20movie%20aesthetic&width=800&height=450&seq=carousel-01&orientation=landscape',
    heat: '9.8',
  },
  {
    id: 2,
    title: '悬疑烧脑季·高分推理片单',
    tag: '编辑精选',
    desc: '精心挑选的悬疑佳作，层层反转、步步惊心。从经典本格推理到现代心理悬疑，每一帧都暗藏线索，考验你的观察力与推理能力。',
    img: 'https://readdy.ai/api/search-image?query=Mystery%20thriller%20cinematic%20scene%20with%20shadowy%20figure%20in%20dim%20alley%2C%20dramatic%20contrast%20lighting%2C%20film%20noir%20style%2C%20deep%20dark%20tones%20with%20warm%20accent%20light%2C%20suspenseful%20atmosphere%2C%20elegant%20composition&width=800&height=450&seq=carousel-02&orientation=landscape',
    heat: '9.5',
  },
  {
    id: 3,
    title: '科幻视界·未来世界漫游指南',
    tag: '热门专题',
    desc: '从AI觉醒到星际穿越，精选最具想象力的科幻电影。震撼的视觉特效与深刻的人文思考交织，带你探索未知宇宙的无限可能。',
    img: 'https://readdy.ai/api/search-image?query=Futuristic%20sci-fi%20cinematic%20scene%20with%20glowing%20neon%20elements%20on%20dark%20space%20background%2C%20abstract%20geometric%20patterns%2C%20cool%20and%20warm%20light%20contrast%2C%20minimalist%20tech%20aesthetic%2C%20atmospheric%20composition&width=800&height=450&seq=carousel-03&orientation=landscape',
    heat: '9.3',
  },
  {
    id: 4,
    title: '国产之光·年度口碑华语片',
    tag: '特别企划',
    desc: '2026年华语电影的惊喜之作尽在这里。从现实题材到奇幻史诗，国产电影人用镜头讲述打动人心的中国故事，每一部都值得细细品味。',
    img: 'https://readdy.ai/api/search-image?query=Elegant%20Chinese%20cinema%20artistic%20scene%20with%20traditional%20and%20modern%20elements%20blend%2C%20warm%20golden%20and%20crimson%20tones%2C%20soft%20cinematic%20lighting%2C%20cultural%20aesthetic%2C%20dark%20atmospheric%20background%2C%20film%20festival%20quality&width=800&height=450&seq=carousel-04&orientation=landscape',
    heat: '9.6',
  },
];

export default function CarouselSection() {
  return (
    <section id="carousel" className="py-14 md:py-20 bg-background-100">
      <div className="w-full max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="font-heading text-xl md:text-3xl font-bold text-foreground-950 mb-3">
            本周精选
          </h2>
          <p className="text-sm text-foreground-400 max-w-[500px] mx-auto">
            编辑团队每周精选优质影片专题，为您推荐不容错过的高清佳作
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-5 md:gap-6">
          {carouselItems.map((item) => (
            <article
              key={item.id}
              className="group relative rounded-lg overflow-hidden bg-background-200 border border-background-200/50 hover:border-primary-500/30 transition-all duration-300 cursor-pointer"
            >
              <div className="relative aspect-[16/9] overflow-hidden">
                <img
                  src={item.img}
                  alt={item.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-background-200/95 via-background-200/30 to-transparent"></div>
                <span className="absolute top-3 left-3 px-2.5 py-1 rounded-full bg-accent-500/85 text-background-50 text-xs font-semibold">
                  {item.tag}
                </span>
                <span className="absolute top-3 right-3 px-2 py-0.5 rounded-md bg-background-50/70 backdrop-blur-sm text-primary-600 text-xs font-bold">
                  <i className="ri-star-fill mr-0.5 text-xs"></i>
                  {item.heat}
                </span>
              </div>
              <div className="p-4 md:p-5">
                <h3 className="font-heading text-base md:text-lg font-bold text-foreground-950 mb-2 group-hover:text-primary-500 transition-colors">
                  {item.title}
                </h3>
                <p className="text-sm text-foreground-400 leading-relaxed line-clamp-2">
                  {item.desc}
                </p>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}